<template style="height: 100%;">
  <div class="content-body">
    <h2 v-if="IsInit && !IsGuide">{{ PaperInfo.PaperName }}</h2>
    <div v-if="IsInit" class="paper-content">
      <div v-if="!IsGuide" class="paper-guide" v-html="PaperInfo.Guide">
        {{ PaperInfo.Guide }}
      </div>
      <div class="ct-user" v-if="IsGuide">
        <div class="paper-left-p">
          <el-row><div class="paper-tip">请选择被试对象</div></el-row>
          <el-row class="paper-item">
            <div class="item-lable">账号：</div>
            <div class="item-text">
              <el-input
                v-model="User.UserID"
                placeholder="选择用户"
                class="input-text"
                disabled
              ></el-input>
            </div>
          </el-row>
          <el-row class="paper-item">
            <div class="item-lable">年龄：</div>
            <div class="item-text">
              <el-input
                v-model="User.Age"
                placeholder="输入年龄"
                class="input-text"
                @blur="InputCheck(User.Age, 'age')"
              ></el-input>
            </div>
          </el-row>
          <el-row class="paper-item">
            <div class="item-lable">居住地：</div>
            <div class="item-text">
              <el-select
                v-model="User.AccountType"
                placeholder="请选择"
                class="input-text"
              >
                <el-option
                  v-for="item in NodeType"
                  :key="item.Key"
                  :label="item.Value"
                  :value="item.Key"
                ></el-option>
              </el-select>
            </div>
          </el-row>
          <el-row class="paper-item">
            <div class="item-lable">文化程度：</div>
            <div class="item-text">
              <el-select
                v-model="User.Degree"
                placeholder="请选择"
                class="input-text"
              >
                <el-option
                  v-for="item in Degree"
                  :key="item.Key"
                  :label="item.Value"
                  :value="item.Key"
                ></el-option>
              </el-select>
            </div>
          </el-row>
          <el-row class="paper-item">
            <div class="item-lable">被试态度：</div>
            <div class="item-text">
              <el-select
                v-model="User.Attitude"
                placeholder="请选择"
                class="input-text"
              >
                <el-option
                  v-for="item in Attitude"
                  :key="item.Key"
                  :label="item.Value"
                  :value="item.Key"
                ></el-option>
              </el-select>
            </div>
          </el-row>
          <el-row class="buttom-row">
            <el-button type="primary" @click="dialogUser = true">
              选择被试者
            </el-button>
          </el-row>
        </div>
      </div>
      <div class="ct-paper" v-if="IsGuide">
        <div class="paper-right-p">
          <el-row><div class="paper-tip">请输入四舍五入之后的整数</div></el-row>
          <el-row v-for="item in PaperItem" :key="item.Key" class="paper-item">
            <div class="item-lable">{{ item.Name }}</div>
            <div class="item-text">
              <el-input
                v-model="item.Value"
                placeholder="请输入值"
                class="input-text"
                @blur="InputCheck(item.Value, 'paper')"
              ></el-input>
            </div>
          </el-row>
          <el-row class="buttom-row">
            <el-button type="primary" @click="Submit">
              提交
            </el-button>
          </el-row>
        </div>
      </div>
      <el-dialog
        title="受试者列表"
        :visible.sync="dialogUser"
        :close-on-click-modal="false"
      >
        <el-table
          :data="UserList"
          stripe
          ref="singleTable"
          highlight-current-row
          @current-change="handleCurrentChange"
          style="width: 100%;"
        >
          <el-table-column
            property="Index"
            label="序号"
            width="200"
            :center="true"
          ></el-table-column>
          <el-table-column
            property="UserID"
            label="账号"
            width="200"
            :center="true"
          ></el-table-column>
          <el-table-column
            property="Name"
            label="姓名"
            width="200"
          ></el-table-column>
          <el-table-column
            property="Sex"
            label="性别"
            width="169"
          ></el-table-column>
          <el-table-column
            property="Birthday"
            label="出生日期"
          ></el-table-column>
        </el-table>
        <el-pagination
          background
          layout="total, prev, pager, next"
          :page-size="10"
          :total="AllCount"
          @current-change="current_change"
        ></el-pagination>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="SelectUser"
            :disabled="
              SelectObj == null || SelectObj.UserID == '' ? true : false
            "
          >
            确 定
          </el-button>
        </span>
      </el-dialog>
      <el-row v-if="IsInit && !IsGuide">
        <el-button type="primary" @click="StartPaperTest">
          开始测试
        </el-button>
      </el-row>
    </div>

    <div v-if="!IsInit" class="data-load">
      <div class="data-load-tip">
        <img src="../../assets/loadingbar.gif" alt="load" />
        <div>拼命加载中...</div>
      </div>
    </div>

    <el-dialog
      :title="PaperInfo.PublishSubject + '指导语'"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>{{ PaperInfo.StartGuidelines }}</span>
    </el-dialog>

    <el-dialog
      :title="PaperInfo.PublishSubject + '指导语'"
      :visible.sync="dialogVisible2"
      width="30%"
    >
      <span>{{ PaperInfo.FinishGuidelines }}</span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      dialogVisible2: false,
      IsInit: false,
      PaperID: '',
      IsGuide: false,
      NodeType: [
        { Key: 0, Value: '城市' },
        { Key: 1, Value: '农村' },
      ],
      Degree: [
        { Key: 1001, Value: '博士' },
        { Key: 1002, Value: '硕士' },
        { Key: 1003, Value: '本科' },
        { Key: 1004, Value: '大专' },
        { Key: 1005, Value: '中专' },
        { Key: 1006, Value: '高中' },
        { Key: 1007, Value: '初中' },
        { Key: 1008, Value: '小学' },
        { Key: 1009, Value: '文盲' },
      ],
      Attitude: [
        { Key: 0, Value: '被试对测验能够合作，测试顺利' },
        { Key: 1, Value: '被试对测验不愿合作，测试不顺利' },
      ],
      UserInfo: {
        TesterID: '',
        Account: '',
        Name: '',
      },
      PaperItem: [
        { Key: 'T001', Name: '常识（I）粗分：', MaxValue: 29, Value: '' },
        { Key: 'T002', Name: '领悟力（C）粗分：', MaxValue: 28, Value: '' },
        { Key: 'T003', Name: '算术（A）粗分：', MaxValue: 18, Value: '' },
        { Key: 'T004', Name: '相似性（S）粗分：', MaxValue: 22, Value: '' },
        { Key: 'T005', Name: '数字广度（D）粗分：', MaxValue: 26, Value: '' },
        { Key: 'T006', Name: '词汇（V）粗分：', MaxValue: 80, Value: '' },
      ],
      UserList: [],
      dialogUser: false,
      SelectObj: null,
      User: {
        UserID: '',
        Account: '',
        Name: '',
        Sex: '',
        Birthday: '',
      },
      SourceNo: '0',
      StartDateTime: '',
      EndDateTime: '',
      PaperInfo: {},
      PageInfo: {
        CurrentIndex: 0,
        PageSize: 10,
        PageIndex: 0,
        TotleCount: 0,
        TotlePageCount: 0,
      },
      AllCount: -1,
    }
  },
  mounted: function () {
    this.PaperID = this.$route.query.PaperID
    this.SourceNo = this.$route.query.PublishID
    this.InitPaper()
    this.GetUserList()
  },
  methods: {
    InitPaper() {
      let _this = this
      this.$Http_Post('Paper/GetPaperInfo', {
        SourceNo: _this.SourceNo,
        PaperID: _this.PaperID,
        UserID: '',
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.PaperInfo = res.Data
          _this.IsInit = true
          if (_this.PaperInfo.StartGuidelines) {
            _this.dialogVisible = true
          } else {
            _this.dialogVisible = false
          }
        } else {
          this.$message({
            type: 'error',
            message: '初始化量表失败',
          })
        }
      })
    },
    StartPaperTest() {
      this.IsGuide = true
      this.StartDateTime = this.Global.getCurrentTime()
    },
    InputCheck(val, obj) {
      if (val != '') {
        this.$message.closeAll()
        if (!this.User.UserID || this.User.UserID == '') {
          this.$message({
            type: 'warning',
            message: '请选择被试者',
          })
        } else {
          if (obj == 'age') {
          }
        }
      }
    },
    current_change: function (currentPage) {
      this.PageInfo.PageIndex = currentPage
      this.GetUserList()
    },
    Submit: function () {
      let state = true

      if (this.User.UserID === '') {
        this.$message.closeAll()
        this.$message({
          type: 'warning',
          message: '请选择被试者',
        })
        state = false
        return
      } else {
        if (this.User.Age < 16) {
          this.$message({
            type: 'warning',
            message: '年龄不能小于16岁',
          })
          this.User.Age = ''
          return
        } else if (this.User.Age > 100) {
          this.$message({
            type: 'warning',
            message: '年龄不能大于100岁',
          })
          this.User.Age = ''
          state = false
          return
        }
      }

      for (let i = 0; i < this.PaperItem.length; i++) {
        if (this.PaperItem[i].Value == '') {
          this.$message.closeAll()
          this.$message({
            type: 'warning',
            message:
              '请填写' +
              this.PaperItem[i].Name.slice(
                0,
                this.PaperItem[i].Name.length - 1,
              ) +
              '的值',
          })
          state = false
        } else if (this.PaperItem[i].Value > this.PaperItem[i].MaxValue) {
          this.$message({
            type: 'warning',
            message:
              this.PaperItem[i].Name + '不能大于' + this.PaperItem[i].MaxValue,
          })
          state = false
        }
        if (!state) return
      }

      if (state) {
        this.EndDateTime = this.Global.getCurrentTime()
        let tmpRst =
          this.Global.userID +
          ',' +
          this.User.Age +
          ',' +
          this.User.AccountType +
          ',' +
          this.User.Degree +
          ',' +
          this.User.Attitude +
          ';'
        this.PaperItem.forEach((item, idx) => {
          tmpRst += item.Value + ','
        })
        let result = {
          PaperResultID: '',
          SourceNo: this.SourceNo,
          SourceFlg: 1,
          PaperID: this.PaperID,
          PaperTestProgress: 0,
          UserID: this.User.UserID,
          StartDateTime: this.StartDateTime,
          EndDateTime: this.EndDateTime,
          TmpResult: tmpRst,
          IsSubmit: 1,
          Creator: this.User.UserID,
          SourceFlg: this.$route.query.type,
        }
        this.$Http_Post('Paper/Submit', { data: result }).then((res) => {
          this.$message.closeAll()
          if (res.Code == 200 || res.Code == 0) {
            this.$router.go(-1)
            this.$message({
              type: 'success',
              message: res.Message,
            })
          } else {
            this.$message({
              type: 'error',
              message: '量表提交失败',
            })
          }
        })
      }
    },
    handleCurrentChange: function (val) {
      this.SelectObj = val
    },
    SelectUser: function () {
      this.dialogUser = false
      this.User = this.SelectObj
    },
    GetUserList() {
      this.$Http_Post('User/GetAllUserList', {
        pageSize: this.PageInfo.PageSize,
        pageIndex: this.PageInfo.PageIndex,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.UserList = res.Data.UserList
          this.AllCount = res.Data.AllCount
        }
      })
    },
    NextPage: function () {},
  },
}
</script>
<style>
.content-body .data-load {
  width: 100%;
  height: 100%;
  position: relative;
}

.content-body h2 {
  line-height: 50px;
  height: 50px;
  text-align: center;
}
.content-body .data-load-tip {
  width: 214px;
  height: 80px;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
  line-height: 30px;
  color: cornflowerblue;
}

.content-body .content-body {
  border: 1px solid #e4e7ed;
  background-color: #f6fafb;
  height: calc(100% - 35px);
  padding: 20px;
  border-radius: 5px;
}

.content-body .paper-content {
  width: 100%;
  height: 100%;
}

.content-body .paper-guide {
  width: 50%;
  text-align: left;
  margin: 0 auto;
}

.content-body .ct-user {
  width: calc(50% - 10px);
  height: 100%;
  float: left;
  background-color: #f8f7f2;
  position: relative;
}

.content-body .ct-paper {
  width: calc(50% - 10px);
  height: 100%;
  float: right;
  background-color: #f8f7f2;
  position: relative;
}

.content-body .paper-tip {
  text-align: center;
  height: 50px;
  line-height: 50px;
  color: red;
}

.content-body .paper-left-p {
  width: 100%;
  position: absolute;
  top: 50%;
  margin-top: -202px;
}

.content-body .paper-right-p {
  width: 100%;
  position: absolute;
  top: 50%;
  margin-top: -232px;
}
.content-body .paper-item {
  padding: 5px 10px;
  line-height: 40px;
}

.content-body .item-lable {
  padding-right: 20px;
  width: calc(50% - 10px);
  text-align: right;
  float: left;
}

.content-body .item-text {
  width: calc(50% - 20px);
  float: right;
}

.content-body .input-text {
  width: 70% !important;
}

.content-body .item-text input {
  width: 100%;
}

.content-body .buttom-row {
  text-align: center;
  margin-top: 10px;
}

.content-body .current-row {
  background-color: #92bfed !important;
}

.content-body .el-row {
  text-align: center;
  margin-bottom: 0px !important;
}

.content-body .el-table__body tr.current-row > td,
.content-body
  .el-table--striped
  .el-table__body
  tr.el-table__row--striped.current-row
  td {
  background-color: #98c7fb !important;
  color: white;
}

.content-body .el-dialog__footer {
  margin-top: 10px;
}
</style>
